var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84.2642,
    height: 121.024,
    viewBox: "102.859 51.6084 84.2642 121.024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter08)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.859 76.3604V92.7924C181.859 98.959 179.538 103.947 174.896 107.756C173.674 108.759 173.761 110.798 175.07 111.686C180.439 115.327 183.123 120.405 183.123 126.92V145.88C183.123 152.2 180.911 157.572 176.487 161.996C172.063 166.42 166.691 168.632 160.371 168.632H125.611C119.291 168.632 113.919 166.42 109.495 161.996C105.071 157.572 102.859 152.2 102.859 145.88V126.92C102.859 120.405 105.543 115.327 110.912 111.686C112.22 110.798 112.308 108.759 111.085 107.756C106.444 103.947 104.123 98.959 104.123 92.7924V76.3604C104.123 70.0404 106.335 64.6684 110.759 60.2444C115.183 55.8204 120.555 53.6084 126.875 53.6084H159.107C165.427 53.6084 170.799 55.8204 175.223 60.2444C179.647 64.6684 181.859 70.0404 181.859 76.3604ZM152.787 74.7804H133.195C128.982 74.7804 126.875 76.8871 126.875 81.1004V93.4244C126.875 95.8471 127.349 97.5324 128.297 98.4804C129.245 99.3231 130.878 99.7444 133.195 99.7444H152.787C155.104 99.7444 156.737 99.3231 157.685 98.4804C158.633 97.5324 159.107 95.8471 159.107 93.4244V81.1004C159.107 76.8871 157 74.7804 152.787 74.7804ZM152.787 119.968H133.195C128.139 119.968 125.611 122.075 125.611 126.288V141.14C125.611 145.354 127.718 147.46 131.931 147.46H154.051C158.264 147.46 160.371 145.354 160.371 141.14V126.288C160.371 122.075 157.843 119.968 152.787 119.968Z",
    fill: "#4E0109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.859 76.3604V92.7924C181.859 98.959 179.538 103.947 174.896 107.756C173.674 108.759 173.761 110.798 175.07 111.686C180.439 115.327 183.123 120.405 183.123 126.92V145.88C183.123 152.2 180.911 157.572 176.487 161.996C172.063 166.42 166.691 168.632 160.371 168.632H125.611C119.291 168.632 113.919 166.42 109.495 161.996C105.071 157.572 102.859 152.2 102.859 145.88V126.92C102.859 120.405 105.543 115.327 110.912 111.686C112.22 110.798 112.308 108.759 111.085 107.756C106.444 103.947 104.123 98.959 104.123 92.7924V76.3604C104.123 70.0404 106.335 64.6684 110.759 60.2444C115.183 55.8204 120.555 53.6084 126.875 53.6084H159.107C165.427 53.6084 170.799 55.8204 175.223 60.2444C179.647 64.6684 181.859 70.0404 181.859 76.3604ZM152.787 74.7804H133.195C128.982 74.7804 126.875 76.8871 126.875 81.1004V93.4244C126.875 95.8471 127.349 97.5324 128.297 98.4804C129.245 99.3231 130.878 99.7444 133.195 99.7444H152.787C155.104 99.7444 156.737 99.3231 157.685 98.4804C158.633 97.5324 159.107 95.8471 159.107 93.4244V81.1004C159.107 76.8871 157 74.7804 152.787 74.7804ZM152.787 119.968H133.195C128.139 119.968 125.611 122.075 125.611 126.288V141.14C125.611 145.354 127.718 147.46 131.931 147.46H154.051C158.264 147.46 160.371 145.354 160.371 141.14V126.288C160.371 122.075 157.843 119.968 152.787 119.968Z",
    fill: "url(#paint0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter08",
    x: 102.859,
    y: 51.6084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0",
    x1: 142.991,
    y1: 53.6084,
    x2: 212.794,
    y2: 139.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.398452,
    stopColor: "#C40F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8102E",
    stopOpacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.662c4ae1c306fa68532442de432cd0f7.svg";
export { ForwardRef as ReactComponent };